
import Vue from 'vue'

type Question = {
  content: string;
  slug: string;
  answerType: 'radio' | 'text';
  options?: Array<string>;
}
type DataState = {
  isLoading: boolean;
  questions: Array<Question>;
  currentQuestionIndex: number;
  answer: '';
}

export default Vue.extend({
  name: 'SurveyDialog',

  props: {
    isOpen: { type: Boolean },
    onClose: { type: Function },
    type: { type: String },
    user: { type: Object || null },
  },

  data: (): DataState => ({
    isLoading: true,
    questions: [],
    currentQuestionIndex: 0,
    answer: '',
  }),

  computed: {
    currentQuestion(): Question {
      return this.questions[this.currentQuestionIndex];
    },

    hasNextQuestion(): boolean {
      return this.questions.length - 1 !== this.currentQuestionIndex;
    }
  },

  watch: {
    answer(newVal: string) {
      if (newVal && newVal.startsWith('=')) {
        this.answer = newVal.replace(/^=+/, '');
      }
    }
  },

  mounted() {
    this.$api.get(`/surveys/questions/${this.type}`)
      .then(res => this.questions = res.data.questions)
      .finally(() => this.isLoading = false);
  },

  methods: {
    handleSubmit() {
      this.$api.post('/surveys', {
        user: this.user.id,
        slug: this.currentQuestion.slug,
        answer: this.answer,
      })
        .then(() => {
          if (this.hasNextQuestion) {
            this.currentQuestionIndex += 1;
            this.answer = '';
          } else {
            this.onClose(this.type, true);
          }
        })
        .catch(() => {
          this.$store.dispatch('alert/error', 'Error while sending survey.');
          this.onClose(this.type);
        });
    },
  },
})
